import React, { useEffect, useState } from "react";
import "./Awards.css";
import Navber from "../../Components/Navber";
import ImageLightbox from "../../Components/Helping Component/ImageZoom.jsx";

const Awards = () => {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);

  useEffect(() => {
    fetch("https://admintest.jayrajgroup.org/api/awards")
      .then((res) => res.json())
      .then((data) => {
        if (data.status) setAwards(data.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="awards-loader">Loading Awards…</div>;

  const toggle = (id) =>
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));

  const openImages = (award) => {
    setCurrentImages(award.media.map((m) => m.full_url));
    setLightboxOpen(true);
  };

  return (
    <section className="awards-page">
      <Navber />

      <ImageLightbox
        open={lightboxOpen}
        setOpen={setLightboxOpen}
        images={currentImages}
      />

      <div className="awards-hero">
        <h1>Certificates & Our Achievements</h1>
        <p>A timeline of excellence & recognition</p>
      </div>

      <div className="awards-timeline">
        {awards.map((award, index) => (
          <div
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
            key={award.id}
          >
            {/* IMAGE */}
            <div
              className="timeline-image"
              onClick={() => openImages(award)}
            >
              <img
                src={award.media[0]?.full_url}
                alt={award.title}
              />
              <span>View Gallery</span>
            </div>

            {/* CONTENT */}
            <div className="timeline-content">
              <h2>{award.title}</h2>
              <h4>{award.sub_title}</h4>

              <div
                className={`timeline-desc ${
                  expanded[award.id] ? "open" : ""
                }`}
                dangerouslySetInnerHTML={{
                  __html: award.description,
                }}
              />

              <button onClick={() => toggle(award.id)}>
                {expanded[award.id] ? "Show Less" : "Read More"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Awards;
